<script setup lang="ts">
/**
 * By default, the loader centers itself in-place (normal document flow, no positioned
 * ancestor required). Use `overlay` to instead cover the nearest positioned ancestor
 * (position: relative/absolute/fixed/sticky) and dim the content behind it.
 */
const { overlay = false } = defineProps<{ overlay?: boolean }>()
</script>

<template>
  <div
    v-if="overlay"
    class="funkwhale loader-container"
  >
    <div class="funkwhale">
      <div class="loader" />
    </div>
  </div>

  <div
    v-else
    class="funkwhale"
  >
    <div class="loader" />
  </div>
</template>

<style>
.loader-container {
  position: absolute;
  width: 100%;
  height: 100%;
  grid-column: 1 / -1;
  grid-row: 1 / -1;
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;
}

.loader {
  border-radius: 50%;
  animation: spin 0.6s linear 8; /* spin 8x, i.e. 4.9s ;-) */

  font-size: 1.2em;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -0.75em;
  margin-top: -0.75em;
  text-indent: -9999em;
  border-top: 0.2em solid color-mix(in oklab, transparent 80%, currentcolor);
  border-right: 0.2em solid color-mix(in oklab, transparent 80%, currentcolor);
  border-bottom: 0.2em solid color-mix(in oklab, transparent 80%, currentcolor);
  border-left: 0.2em solid color-mix(in oklab, transparent 20%, currentcolor);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
